module.exports = __webpack_public_path__ + "AvertaCyrillic-Bold.45c2f35d836ffaa8145c.ttf";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/assets/fonts/AvertaCyrillic-Bold.ttf
// module id = ../../../../../src/assets/fonts/AvertaCyrillic-Bold.ttf
// module chunks = styles